import { useState } from "react";
import { Button, Modal } from "antd";
import { DeleteOutlined, CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import "./DeleteButton.scss";
import { withLocale } from "../../l10n";

function DeleteButton({ onEvent, buttonDisabled, willBeDeleted = [], willStay = [], lang }) {
  // ===== 1. ESTADOS =====
  const [open, setOpen] = useState(false);

  // ===== 2. HANDLERS =====
  const showModal = () => {
    setOpen(true);
  };

  const confirmDelete = () => {
    if (onEvent) onEvent();
    setOpen(false);
  };

  const cancelDelete = () => {
    setOpen(false);
  };

  // ===== 3. RENDER =====
  return (
    <>
      <Button
        type="primary"
        onClick={showModal}
        icon={<DeleteOutlined />}
        disabled={buttonDisabled}
      >
        {lang.handle("Eliminar")}
      </Button>

      <Modal
        title={lang.handle("Confirmación de eliminación")}
        open={open}
        onOk={confirmDelete}
        onCancel={cancelDelete}
        okText={lang.handle("Sí, eliminar")}
        cancelText={lang.handle("Cancelar")}
      >
                <p>{lang.handle("¿Está seguro de que desea eliminar este elemento?")}</p>

        {willBeDeleted.length > 0 && (
          <div className="delete-summary delete-summary--danger">
            <div className="delete-summary__title">{lang.handle('Se eliminarán')}:</div>
            <ul className="delete-summary__list">
              {willBeDeleted.map(item => (
                <li key={item}><CloseCircleOutlined /> {item}</li>
              ))}
            </ul>
          </div>
        )}

        {willStay.length > 0 && (
          <div className="delete-summary delete-summary--safe">
            <div className="delete-summary__title">{lang.handle('Se mantendrá')}:</div>
            <ul className="delete-summary__list">
              {willStay.map(item => (
                <li key={item}><CheckCircleOutlined /> {item}</li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
    </>
  );
}

export default withLocale(DeleteButton);
